import axios from "axios";
let cancelTokenSource = axios.CancelToken.source();
export function createNavigationGuards(router) {
  router.beforeEach(async (to, from, next) => {
    document.title = to.meta.title || "VE";
    // if (!document.cookie) {
    //   next({ name: "login", replace: true });
    //   return;
    // }
    cancelTokenSource.cancel("页面切换，取消请求");
    cancelTokenSource = axios.CancelToken.source();
    next();
  });
}
